

















































































































































































































































































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import useRoomEditor from "@/composables/room/use-room-editor.ts";
// eslint-disable-next-line no-unused-vars
import { RoomInfo } from "@/services/room.service";
import attendTime from "@/mock/attendTime.ts";
import ValidateError from "@/components/common/ValidateError.vue";

@Component({ components: { ValidateError } })
export default class RoomEditor extends Vue {
  @Prop()
  private isUpdate!: boolean;

  @Prop()
  private roomData?: RoomInfo;

  @Emit("on-success")
  onSuccess(): void {
    //
  }

  @Emit("on-fail")
  onFail(): void {
    //
  }

  private attendDropdown = attendTime;

  setup(props: { isUpdate: boolean; roomData: RoomInfo }, context: any) {
    const {
      room,
      createRoom,
      updateRoom,
      validation,
      isLoading
    } = useRoomEditor({
      roomData: props.roomData,
      emit: context.emit
    });

    return { room, createRoom, updateRoom, validation, isLoading };
  }
}
